/** 子菜单项的角标（如 New）：侧栏弹出菜单、触屏列表和手机抽屉三处共用 */
export function NavBadge({ label }: { label: string }) {
	return (
		<span className="ml-auto shrink-0 rounded-full bg-primary px-1.5 font-semibold text-[10px] text-primary-foreground uppercase leading-4">
			{label}
		</span>
	);
}
